import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ItemCell } from './item-cell';
import { messages } from './messages';
import style from './style.module.less';
import { FormattedCurrency } from '../../../../../../../components/formatted-currency';
import { UserDateTimezoneFormat } from '../../../../../../../components/user-date-timezone-format';
import { useUtcFormattedDate } from '../../../../../../../hooks/use-datetime-formats';

// selectUserUserDateFormat
// selectUserUserTimeFormat

// Taken from v2
const inventoryTransactionTypes = {
  1: <FormattedMessage {...messages.inventoryTransactionTypeAdd} />,
  2: <FormattedMessage {...messages.inventoryTransactionTypeRemove} />,
  3: <FormattedMessage {...messages.inventoryTransactionTypeAllocate} />,
  4: <FormattedMessage {...messages.inventoryTransactionTypeReleaseAllocation} />,
  5: <FormattedMessage {...messages.inventoryTransactionTypeCommitAllocation} />,
  6: <FormattedMessage {...messages.inventoryTransactionTypeMove} />,
  7: <FormattedMessage {...messages.inventoryTransactionTypeDeallocate} />,
};

/**
 * @typedef {object} Cost
 * @property {number} value
 * @property {string} code
 */

/**
 * @typedef {object} HistoryItem
 * @property {string} addedOn
 * @property {Cost} cost
 * @property {string} description
 * @property {boolean} isPickable
 * @property {string} name
 * @property {number} transactionType
 * @property {number} units
 * @property {string} warehouseLocation
 * @property {string} warehouseName
 * @property {string} lot
 * @property {string} expirationDate
 */

/**
 * @param {object} props
 * @param {HistoryItem} props.historyItem
 * @param {string} [props.inventoryLocationId]
 * @returns {JSX.Element}
 */

export const HistoryItemBody = ({ historyItem, inventoryLocationId = undefined }) => {
  const formattedExpirationDate = useUtcFormattedDate(historyItem.expirationDate);

  return (
    <div className={!inventoryLocationId ? style['items-body-extended'] : style['items-body']}>
      <ItemCell>{historyItem.units}</ItemCell>
      <ItemCell>
        <FormattedCurrency currencyCode={historyItem.cost.code} value={historyItem.cost.value} />
      </ItemCell>
      <ItemCell>
        <UserDateTimezoneFormat dateTime={historyItem.addedOn} />
      </ItemCell>
      {!inventoryLocationId && (
        <>
          <ItemCell>{historyItem.lot}</ItemCell>
          <ItemCell>{formattedExpirationDate}</ItemCell>
        </>
      )}
      <ItemCell>{historyItem.name}</ItemCell>
      <ItemCell>{historyItem.description}</ItemCell>
      <ItemCell>{inventoryTransactionTypes[historyItem.transactionType]}</ItemCell>
    </div>
  );
};
